export const Config = {
    apiEndpoint: 'https://us-central1-quiz-night-8766d.cloudfunctions.net',
    getReadyTimerLength: 6 * 1000,
}
